import styled from "styled-components";
import { CLOUDN_COLORS } from "../../../constants/colors";
import LinkListBox from "../../molecules/link/LinkListBox";
import { LinkListCardProps } from "../../../constants/types";
import { useEffect, useState } from "react";

const LinkListCard = (props: LinkListCardProps) => {
  const [elements, setElements] = useState<JSX.Element[]>([]);

  useEffect(() => {
    setElements(
      props.links.map((data, index) => (
        <LinkListBox
          key={index}
          groupName={data.groupName}
          links={data.links}
        />
      ))
    );
  }, [props.links]);

  return <Container>{elements}</Container>;
};

export default LinkListCard;

const Container = styled.div`
  width: 74%;
  height: 100%;
  border: 0.2vw solid ${CLOUDN_COLORS.logoSkyBlue};
  box-sizing: border-box;

  padding: 1%;

  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
